export const selectFilterProcessor = ({ inputQuery, query, key, filterData, filter }) => {
	let active = false;
	const activeOptions = [];

	const { options: rawOptions, ...injectionProps } = filterData[key] ?? {};

	const options = (rawOptions ?? []).map(option => {
		var values = typeof query[key] === 'object' ? query[key] : ((query && query[key]) ? [query[key]] : []);
		var inputValues = typeof inputQuery[key] === 'object' ? inputQuery[key] : ((inputQuery && inputQuery[key]) ? [inputQuery[key]] : []);
		if(filter.valueFormat !== 'array') { values = values.length > 0 ? values[0] : []; }
		const selected = values.includes(option[filter.valueKey]?.toString?.());
		const selectedOnQuery = inputValues.includes(option[filter.valueKey]?.toString?.());
		if(selected) {
			active = true;
			activeOptions.push(option);
		}

		return {
			...option,
			value: option[filter.valueKey ?? 'value'],
			label: option[filter.labelKey ?? 'name'],
			selected,
			selectedOnQuery,
		};
	});

	return {
		...filter,
		...injectionProps,
		key,
		active,
		disabled: !!injectionProps.disabled,
		options,
		activeOptions,
		sumText: activeOptions.map(o => o[filter.labelKey ?? 'name']).join(', '),
	}
}